import {
  DOMParser,
  Node as ProsemirrorNode,
  ParseOptions,
  Slice,
  Schema,
} from 'hubspot-prosemirror/pm/model';
import { schema as defaultSchema } from '../ProsemirrorSchema';
import { schema as basicSchema } from 'hubspot-prosemirror/pm/schema-basic';
import Raven from 'raven-js';

export const fullParser = new DOMParser(defaultSchema, [
  { tag: 'br', closeParent: true, context: 'paragraph/' },
  // @ts-ignore not in types
  ...DOMParser.schemaRules(defaultSchema),
]);

export const hsBasicParser = DOMParser.fromSchema(defaultSchema);

export const basicParser = DOMParser.fromSchema(basicSchema);

const captureError = (e: Error, dom: Node, schemaType: string) => {
  const wrapperDiv = document.createElement('div');
  wrapperDiv.appendChild(dom);
  Raven.captureException(e, {
    extra: {
      html: wrapperDiv.innerHTML,
      schemaType,
    },
  });
};
export class SafeParser extends DOMParser {
  parse(dom: Node, options?: ParseOptions): ProsemirrorNode {
    try {
      return super.parse(dom, options);
    } catch (e) {
      // report
      captureError(e as Error, dom, 'Full Schema');
      try {
        return hsBasicParser.parse(dom, options);
      } catch (e2) {
        captureError(e2 as Error, dom, 'HS Basic Schema');
        throw e2;
      }
    }
  }

  parseSlice(dom: Node, options?: ParseOptions): Slice {
    try {
      return super.parseSlice(dom, options);
    } catch (e) {
      // report
      captureError(e as Error, dom, 'Full Schema');
      try {
        return hsBasicParser.parseSlice(dom, options);
      } catch (e2) {
        captureError(e2 as Error, dom, 'HS Basic Schema');
        throw e2;
      }
    }
  }
}

export const getDomParser = (schema: Schema = defaultSchema) => {
  return new SafeParser(schema, [
    { tag: 'br', closeParent: true, context: 'paragraph/' },
    // @ts-ignore not in types
    ...DOMParser.schemaRules(schema),
  ]);
};
